import { isEmpty } from 'lib/array/arrayUtils'
import { useEffect, useRef } from 'react'

export default function useLastNonEmptyValue<T>(value: T): T | undefined {
  const lastNonEmptyValueRef = useRef<T | undefined>(undefined)

  let lastNonEmptyValue = lastNonEmptyValueRef.current
  if (!isEmpty(value)) {
    lastNonEmptyValue = value
  }

  useEffect(() => {
    lastNonEmptyValueRef.current = lastNonEmptyValue
  })

  return lastNonEmptyValue
}
